import { ChangeEvent, FC, useEffect, useState } from 'react'

import { AxiosError } from 'axios'
import { Card, Grid, Input, Select, SimpleCollapse } from 'components'
import { useLoading, useModal } from 'hooks'
import {
  ParamFaleConoscoResponseDto,
  TalkWithUsServices
} from 'services/NGT/Parameterization'
import TalkToUsService, { ITalkToUsEntityResponse } from 'services/NGT/TalkToUs'
import { COLORS, SPACING } from 'utils'

interface IViewNewTalkToUsProps {
  faleConoscoId: number
}

const DEFAULT_TALK_TO_US: ITalkToUsEntityResponse = {
  dtEnvio: '',
  faleConoscoId: 0,
  idParamFaleConosco: 0,
  idUsuario: 0,
  txtMensagem: '',
  txtResposta: '',
  contrato: ''
}

const ViewTalkToUs: FC<IViewNewTalkToUsProps> = ({ faleConoscoId }) => {
  const { showModal } = useModal()
  const { setLoading } = useLoading()

  const [talkToUs, setTalkToUs] =
    useState<ITalkToUsEntityResponse>(DEFAULT_TALK_TO_US)
  const [parametrizationTalkToUs, setParametrizationTalkToUs] =
    useState<ParamFaleConoscoResponseDto>()

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setTalkToUs((oldData) => {
      return {
        ...oldData,
        [event.target.name]: event.target.value
      }
    })
  }

  const [userMessage, setUserMessage] = useState<string>();
  const [userContrato, setUserContrato] = useState<string>();

  const handleUserContratoMessage = (data: ITalkToUsEntityResponse)  => {
    if(data){
      try {
      const userMessageContrato = JSON.parse(data.txtMensagem);
      setUserMessage(userMessageContrato.message);
      setUserContrato(userMessageContrato.CDContrato);
      } catch (error) {
        console.error("handleUserContratoMessage error => ", error);
        setUserContrato("NÃO INFORMADO!");
        setUserMessage(data.txtMensagem);
      }
    }
  }

  const getTalkToUsAnswer = () => {
    TalkToUsService()
      .getById(faleConoscoId)
      .then(({ data }) => {
        if (data) {
          setTalkToUs(data)
          handleUserContratoMessage(data);
          getTalkToUsParametrization(data.idParamFaleConosco)
        }
      })
      .catch((error) => {
        const axiosError = error as AxiosError

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            axiosError.message ||
            'Não foi possivel obter as parametrizações de fale conosco',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const getTalkToUsParametrization = (idParamFaleConosco: number) => {
    setLoading('loading')

    TalkWithUsServices()
      .getById(idParamFaleConosco)
      .then(({ data }) => {
        if (data) {
          setParametrizationTalkToUs(data)
        }
      })
      .catch((error) => {
        const axiosError = error as AxiosError

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            axiosError.message ||
            'Não foi possivel obter as parametrizações de fale conosco',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
      .finally(() => setLoading('idle'))
  }

  useEffect(() => {
    getTalkToUsAnswer()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <SimpleCollapse title="Fale Conosco" textColor={COLORS.black}>
        <Grid
          gridCols="1fr 1.5fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Select
            label="Motivo"
            formValue="idMotivo"
            defaultPlaceholderValue={0}
            value={parametrizationTalkToUs?.idParamFaleConosco || 0}
            disabled
            key="idParamFaleConosco"
            labelMenu="dsMotivo"
            valueMenu="idParamFaleConosco"
            listOptions={
              parametrizationTalkToUs?.idParamFaleConosco
                ? [parametrizationTalkToUs]
                : []
            }
          />
          <Input
            label="Contrato"
            value={userContrato}
            onChange={handleOnChange}
            maxLength={4000}
            disabled
            multiline
            formValue="contrato"
            placeholder="Mensagem"
          />
        </Grid>
        <Grid
          gridCols="1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Input
            label="Mensagem"
            value={userMessage}
            onChange={handleOnChange}
            maxLength={4000}
            disabled
            multiline
            formValue="txtMensagem"
            placeholder="Digite aqui a sua mensagem"
          />
        </Grid>
      </SimpleCollapse>
      {talkToUs.txtResposta && (
        <SimpleCollapse title="Resposta" textColor={COLORS.black}>
          <Grid
            gridCols="1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
          >
            <Input
              label="Digite aqui a sua mensagem"
              formValue="txtResposta"
              disabled
              multiline
              value={talkToUs.txtResposta}
              onChange={handleOnChange}
              placeholder="Mensagem"
            />
          </Grid>
        </SimpleCollapse>
      )}
    </Card>
  )
}

export default ViewTalkToUs
